// extracted by mini-css-extract-plugin
module.exports = {"container":"Message_container__2orjX"};